import { createSelector } from '@reduxjs/toolkit';
import { selectIsApartment, selectOnlyFlat } from 'shared/selectors/jsonQuery';

export const selectApartmentsValue = createSelector([selectIsApartment, selectOnlyFlat], (isApartment, onlyFlat) => {
  if (!onlyFlat && isApartment) {
    return true;
  }

  if (onlyFlat && !isApartment) {
    return false;
  }

  return null;
});
